import {IosOrderDestinations} from "./IosOrderDestinations";
import {OrderDestination} from "../models/OrderRecord";

export const IressDemo = IosOrderDestinations.single(OrderDestination.BESTMKT);
export const Morrison = IosOrderDestinations.single(OrderDestination.BESTMKT);
export const MorrisonTest = IosOrderDestinations.single(OrderDestination.BESTMKT);
export const Om = IosOrderDestinations.of(OrderDestination.AUTODESK,
                                          OrderDestination.AUTODESK,
                                          OrderDestination.BESTMKT);
export const OmTest = IosOrderDestinations.of(OrderDestination.AUTODESK,
                                              OrderDestination.AUTODESK,
                                              OrderDestination.BESTMKT);
export const Phillip = IosOrderDestinations.single(OrderDestination.BESTMKT);
export const Ausiex = IosOrderDestinations.single(OrderDestination.AUTODESK);
export const PhillipTest = IosOrderDestinations.single(OrderDestination.BESTMKT);
export const AusiexTest = IosOrderDestinations.single(OrderDestination.AUTODESK);
export const Shaw = IosOrderDestinations.single(OrderDestination.BESTMKT);
